import { parseQs } from "../../../utils/qs.js";
import { transformWithSpec } from "../../../utils/response.js";
import { ReferralRewardStatusSpecs, ReferralBonusTokenModelSpecs, ReferralRewardEventModelSpecs } from "../../../types/models/refer-balls.specs.js";
function referralRewardsEndpoints(builder) {
  return {
    getReferralRewardStatus: builder.query({
      query: () => ({
        url: `/member/referral/reward/status`,
        method: "GET"
      }),
      transformResponse: transformWithSpec(ReferralRewardStatusSpecs)
    }),
    getReferralRewardTokens: builder.query({
      query: ({ query }) => ({
        url: `/member/referral/reward/tokens${parseQs(query)}`,
        method: "GET"
      }),
      transformResponse: transformWithSpec(ReferralBonusTokenModelSpecs)
    }),
    claimReferralDailyTokens: builder.mutation({
      invalidatesTags: ["referral-rewards"],
      query: () => ({
        url: `/member/referral/reward/daily-claim`,
        method: "POST"
      }),
      transformResponse: transformWithSpec()
    }),
    redeemReferralTokens: builder.mutation({
      invalidatesTags: ["referral-rewards", "funding-tx"],
      query: (body) => ({
        url: `/member/referral/reward/redeem`,
        method: "POST",
        body
      }),
      transformResponse: transformWithSpec()
    }),
    getReferralRewardEvents: builder.query({
      query: ({ query }) => ({
        url: `/member/referral/reward/events${parseQs(query)}`,
        method: "GET"
      }),
      transformResponse: transformWithSpec(ReferralRewardEventModelSpecs)
    })
  };
}
export {
  referralRewardsEndpoints as default
};
